<template>
    <v-alert
        class="form-errors"
        v-if="errors && errors.length"
        dense
        outlined
        type="error"
    >
        <span>Fix some errors</span><br>
        <template v-for="error in errors">
            <span><v-icon color="error">mdi-circle-medium</v-icon>{{ error }}</span><br>
        </template>
    </v-alert>
</template>

<script>
export default {
    name : "ErrorsAlert",
    props: ['errors']
}
</script>

<style scoped>

</style>
